import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type CorrectionDeclinedPayload = {
  bg?: number;
  bolus_id?: number;
  iob?: number;
  target_bg?: number;
  isf?: number;
};

export type CorrectionDeclinedEvent = {
  bg?: number;
  bolusId?: number;
  iob?: number;
  targetBg?: number;
  isf?: number;
};

const correctionDeclinedSchema = z.object({
  bg: cz.permissive(z.number()),
  bolus_id: cz.permissive(z.number()),
  iob: cz.permissive(z.number()),
  target_bg: cz.permissive(z.number()),
  isf: cz.permissive(z.number()),
});

export const LID_CORRECTION_DECLINED = {
  value: 0x5d,
  name: "Correction Declined Event",
  format: "hhfhh........",
  fields: ["bg", "bolus_id", "iob", "target_bg", "isf"],
  postprocess: rec => ({
    bg: rec.bg,
    bolusId: rec.bolus_id,
    iob: rec.iob,
    targetBg: rec.target_bg,
    isf: rec.isf,
  }),
  schema: correctionDeclinedSchema,
} as const satisfies TandemEventDefinition<CorrectionDeclinedPayload, CorrectionDeclinedEvent>;
